import { render, staticRenderFns } from "./assetConfigure.vue?vue&type=template&id=3754ca6b&scoped=true"
import script from "./assetConfigure.vue?vue&type=script&lang=js"
export * from "./assetConfigure.vue?vue&type=script&lang=js"
import style0 from "./assetConfigure.vue?vue&type=style&index=0&id=3754ca6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754ca6b",
  null
  
)

export default component.exports